exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-locations-index-tsx": () => import("./../../../src/pages/locations/index.tsx" /* webpackChunkName: "component---src-pages-locations-index-tsx" */),
  "component---src-pages-partnership-index-tsx": () => import("./../../../src/pages/partnership/index.tsx" /* webpackChunkName: "component---src-pages-partnership-index-tsx" */)
}

